import React from 'react';
import duckLoadingGif from "../assets/UtyaDuck-512px-17.gif"

const LoaderPage = () => {
    return (
        <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", marginTop: "40vh"}}>
            <img src={duckLoadingGif} alt="loading" width={200} height={200}/>
        </div>
    );
};

export default LoaderPage;